import { LanguageType } from "@/enums/enums";
import { GetLanguageType } from "@/helper/userHelper";
import { AccountModel } from "@/model/account/accountModel";
export function ConvertToAccount(accountRawList: any): Array<AccountModel> {
  const unitList: Array<AccountModel> = [];
  if (accountRawList && accountRawList.length > 0) {
    for (const accountRaw of accountRawList) {
      const unit: AccountModel = {
        id: accountRaw.id,
        code: accountRaw.code,
        nameThai: accountRaw.nameThai,
        nameEng: accountRaw.nameEnglish,
        name: GetLanguageType() == LanguageType.En ? accountRaw.nameEnglish : accountRaw.nameThai,
        accountTypeSubId: accountRaw.accountTypeSubId,
        taxIncomeTypeId: accountRaw.taxIncomeTypeId,
        whtValue: accountRaw.whtValue,
        referenceTypeId: accountRaw.referenceTypeId,
        subReferenceTypeId: accountRaw.subReferenceTypeId,
        suggestAccountVatType: accountRaw.accountVatType,
      };
      unitList.push(unit);
    }
  }
  return unitList;
}
